import { useState } from "react";
import { CopyIcon } from "@sanity/icons/Copy";
import {
  DocumentActionComponent,
  DocumentActionDescription,
  useSchema
} from "sanity";
import CloneContentDialog from "./CloneContentDialog";
import { isClonableType } from "./cloneContent";

const CloneContentAction: DocumentActionComponent = ({
  id,
  type,
  draft,
  published,
  onComplete
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const schemaType = useSchema().get(type);
  const target = draft ?? published;

  if (!isClonableType(type)) return null;

  const typeTitle = (schemaType?.title ?? type).toLowerCase();

  return {
    label: `Clone content from ${typeTitle}...`,
    icon: CopyIcon,
    disabled: !target,
    onHandle: () => setDialogOpen(true),
    dialog: dialogOpen &&
      target && {
        type: "dialog",
        header: `Clone content from ${typeTitle}`,
        width: "medium",
        onClose: onComplete,
        content: (
          <CloneContentDialog
            type={type}
            targetId={id}
            target={target}
            onCloned={onComplete}
          />
        )
      }
  } satisfies DocumentActionDescription;
};

export default CloneContentAction;
